import XLSX from 'xlsx';
import moment from 'moment';

const styleCenter = { // 样式不支持,需要用到xlsx的pro版本,要花几百$,但代码还是写着了,据说可以用xlsx-style代替,但是很久没更新了,就作罢
  alignment: {
    vertical: 'center',
    horizontal: 'center',
  }
};

function exportBoxXlsx(listData, editRow, processType) {
  const merges = [];
  let sheetData = {};
  sheetData['A1'] =　{ v: '测试编带机随工单', s: styleCenter };
  merges.push({
    s: { // s为开始
      c: 0,  // 开始列
      r: 0, // 开始行
    },
    e: {
      c: 6,
      r: 0,
    }
  });
  const baseIndex = 2;
  let index = 0, nowIndex, sumPass = 0, sumFail = 0, rowspan = 0, startR, endR;
  nowIndex = baseIndex;

  //订单信息
  sheetData[`A${nowIndex}`] = { v: '子批号', s: styleCenter },
  sheetData[`B${nowIndex}`] = { v: '产品型号', s: styleCenter },
  // sheetData[`C${nowIndex}`] = { v: '型号', s: styleCenter },
  sheetData[`C${nowIndex}`] = { v: '印章号', s: styleCenter },
  sheetData[`D${nowIndex}`] = { v: '数量', s: styleCenter },
  sheetData[`E${nowIndex}`] = { v: '封装厂', s: styleCenter },
  sheetData[`F${nowIndex}`] = { v: '加工项目', s: styleCenter },
  nowIndex++;
  sheetData[`A${nowIndex}`] = { v: editRow.subNo, s: styleCenter },
  sheetData[`B${nowIndex}`] = { v: editRow.product.productName + '/' + editRow.product.chipName, s: styleCenter },
  // sheetData[`C${nowIndex}`] = { v: '型号', s: styleCenter },
  sheetData[`C${nowIndex}`] = { v: editRow.lotNo, s: styleCenter },
  sheetData[`D${nowIndex}`] = { v: editRow.count, s: styleCenter },
  sheetData[`E${nowIndex}`] = { v: '', s: styleCenter },
  sheetData[`F${nowIndex}`] = { v: processType, s: styleCenter },

  nowIndex++;
  nowIndex++;
  sheetData[`A${nowIndex}`] = { v: '序号', s: styleCenter};
  sheetData[`B${nowIndex}`] = { v: '箱号', s: styleCenter }
  sheetData[`C${nowIndex}`] = { v: '箱号条码', s: styleCenter }
  sheetData[`D${nowIndex}`] = { v: '数量', s: styleCenter },
  sheetData[`E${nowIndex}`] = { v: '备注', s: styleCenter },
  sheetData[`F${nowIndex}`] = { v: '结果统计', s: styleCenter }

  // let sheetData = {
  //   A1: { v: '序号', s: styleCenter},
  //   B1: { v: '产品名称', s: styleCenter },
  //   C1: { v: '型号', s: styleCenter },
  //   D1: { v: '印章号', s: styleCenter },
  //   E1: { v: '数量', s: styleCenter },
  //   F1: { v: '封装厂', s: styleCenter },
  //   G1: { v: '加工项目', s: styleCenter },
  //   H1: { v: '备注', s: styleCenter },
  //   I1: { v: '结果统计', s: styleCenter },
  //   J1: { v: '箱号', s: styleCenter },
  //   K1: { v: '箱号条码', s: styleCenter },
  // };
  nowIndex ++;
  for (let i = 0; i < listData.length; i++) {
    let item = listData[i];
    sheetData[`A${nowIndex}`] = {v: i + 1, s: styleCenter};
    sheetData[`B${nowIndex}`] = {v: item.boxNo, s: styleCenter};
    sheetData[`C${nowIndex}`] = {v: '', s: styleCenter};
    sheetData[`D${nowIndex}`] = {v: item.count, s: styleCenter};
    sheetData[`E${nowIndex}`] = {v: item.comment, s: styleCenter};
    sheetData[`F${nowIndex}`] = {v: '', s: styleCenter};
    // sheetData[`J${nowIndex}`] = {v: item.boxNo, s: styleCenter};
    // let view = '<div style="width: 20px;height:20px;background-color: red"></div>';
    // sheetData[`K${nowIndex}`] = {h: view, s: styleCenter};
    nowIndex++;
  }
  sheetData['!merges'] = merges;
  sheetData['!ref'] = `A1:F${nowIndex}`;
  sheetData['!cols'] = [{
    wch: 12 // 单元格列的宽度
  }, {
    wch: 12
  }, {
    wch: 15
  }, {
    wch: 12
  }, {
    wch: 12
  }, {
    wch: 12
  }, {
    wch: 12
  }, {
    wch: 12
  }, {
    wch: 30
  }, {
    wch: 30
  }, {
    wch: 30
  }];
  const sheetName = 'Sheet1';
  const wb = {SheetNames: [`${sheetName}`], Sheets: {}};
  wb.Sheets[`${sheetName}`] = sheetData;
  XLSX.writeFile(wb, 'exportBoxXlsx.xlsx');
}

export default exportBoxXlsx;
